export const MIN_LENGTH_PASSWORD = 4;
export const PIPE_DATE_YEAR_MONTH_DAY = 'dd/MM/yyyy';
export const PIPE_DATE_YEAR_MONTH_DAY_HOURS_MINS_SECONDS = 'dd/MM/yyyy HH:mm:ss';
export const SESSION_POOLS_NAME = 'pools';
export const SESSION_SELECTED_POOL_NAME = 'selected_pool';
export const ALLOWED_POOLS = "custom:allowedPools";
